module.exports = "//static.hsappstatic.net/salesImages/static-1.403/meetings/roundrobin-availability-illustration.svg"